export function getRuntimeConfig() {
    const cfg = (window.ethpandaops?.assertoor?.config ?? {});
    return {
        authProviderURL: cfg.authProviderURL ?? '',
    };
}
